import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import {Item} from '@src/app/models/Item';

@Injectable({
  providedIn: 'root'
})
export class RoomLayoutService {

  private _itemDragEnd = new Subject();
  get parentItemDragEnd$(){
    return this._itemDragEnd.asObservable();
  }
  constructor() {}

  onDragEnd(item:Item){
    if (item.config.getInputProp(Item.SET_UP_AREA_INPUT, 'active')){
      return;
    }
    this._itemDragEnd.next(item);
  }

  isRoomLayoutActive(item:Item):boolean{
    return item.config.getInputProp(Item.SET_UP_AREA_INPUT, 'active');
  }
}
